export interface ICorporationItem {
    value: number,
    name: string,
}
export interface IContractCorporation {
    E: ICorporationItem[];
    P: ICorporationItem[];
    C: ICorporationItem[];
}

export const emptyCorporations: IContractCorporation = { E: [], P: [], C: [] };
